module.exports = __webpack_public_path__ + "static/media/mug.8279182b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/mug.png
// module id = 374
// module chunks = 0